module.exports = __webpack_public_path__ + "img/barnacle_boy.51b9e46a.jpg";